const ActionItems = [
    { "label": "不要", "icon": require('../icons/Actions/不要.png'), "isFolder": false },
    { "label": "听", "icon": require('../icons/Actions/听.png'), "isFolder": false },
    { "label": "呆着", "icon": require('../icons/Actions/呆着.png'), "isFolder": false },
    { "label": "告诉", "icon": require('../icons/Actions/告诉.png'), "isFolder": false },
    { "label": "喝", "icon": require('../icons/Actions/喝.png'), "isFolder": false },
    { "label": "坐", "icon": require('../icons/Actions/坐.png'), "isFolder": false },
    { "label": "工作", "icon": require('../icons/Actions/工作.png'), "isFolder": false },
    { "label": "开始", "icon": require('../icons/Actions/开始.png'), "isFolder": false },
    { "label": "开门", "icon": require('../icons/Actions/开门.png'), "isFolder": false },
    { "label": "打电话", "icon": require('../icons/Actions/打电话.png'), "isFolder": false },
    { "label": "找", "icon": require('../icons/Actions/找.png'), "isFolder": false },
    { "label": "旋转", "icon": require('../icons/Actions/旋转.png'), "isFolder": false },
    { "label": "洗", "icon": require('../icons/Actions/洗.png'), "isFolder": false },
    { "label": "用", "icon": require('../icons/Actions/用.png'), "isFolder": false },
    { "label": "稍等", "icon": require('../icons/Actions/稍等.png'), "isFolder": false },
    { "label": "读书", "icon": require('../icons/Actions/读书.png'), "isFolder": false },
    { "label": "返回", "icon": require('../icons/HOME.png'), "isFolder": true }
];

export default ActionItems;
